
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/usr/src/app/ui/shared/avatar/jst/_avatar.handlebars";
import "/usr/src/app/ui/features/discussion_topic/jst/_author_link.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/usr/src/app/ui/features/discussion-topic/jst/results-entry';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n       <div class=\"discussion-fyi\">";
  stack1 = (helper = helpers.__i18nliner_escape || (depth0 && depth0.__i18nliner_escape),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.editor_href), options) : helperMissing.call(depth0, "__i18nliner_escape", (depth0 && depth0.editor_href), options));
  stack1 = (helper = helpers.__i18nliner_concat || (depth0 && depth0.__i18nliner_concat),options={hash:{},data:data},helper ? helper.call(depth0, "<a href=\"", stack1, "\">$1</a>", options) : helperMissing.call(depth0, "__i18nliner_concat", "<a href=\"", stack1, "\">$1</a>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': (stack1),
    'editor.display_name': (((stack1 = (depth0 && depth0.editor)),stack1 == null || stack1 === false ? stack1 : stack1.display_name)),
    'edited_at': ((depth0 && depth0.edited_at)),
    'i18n_scope': ("discussions.results_entry")
  },data:data},helper ? helper.call(depth0, "discussions.results_entry.edited_comment", "Edited by *%{editor.display_name}* on %{edited_at}", options) : helperMissing.call(depth0, "t", "discussions.results_entry.edited_comment", "Edited by *%{editor.display_name}* on %{edited_at}", options)))
    + "</div>\n      ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        <div class=\"comment_attachments\">\n          ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.attachments), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n      ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <div><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\""
    + escapeExpression((helper = helpers.mimeClass || (depth0 && depth0.mimeClass),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0['content-type']), options) : helperMissing.call(depth0, "mimeClass", (depth0 && depth0['content-type']), options)))
    + "\" title=\"";
  if (helper = helpers.filename) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.filename); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.display_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.display_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a></div>\n          ";
  return buffer;
  }

  buffer += "<article class=\"discussion_entry\">\n  <a href=\"#\"\n     class=\"discussion-read-state-btn\"\n     role=\"button\"\n     title=\"\"\n     data-tooltip='{ \"position\": \"top\", \"collision\": \"none\" }'\n     data-event=\"toggleRead\">\n    <div class=\"discussion-read-state tooltip data-tooltip\"></div>\n  </a>\n  <div class=\"entry-content\">\n    <header class=\"entry-header discussion-section\">\n      ";
  stack1 = self.invokePartial(partials['ui/shared/avatar/jst/_avatar.handlebars'], 'ui/shared/avatar/jst/_avatar.handlebars', (depth0 && depth0.author), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <div class=\"discussion-header-content right-of-avatar\">\n        <div class=\"discussion-header-right\">\n          <div class=\"discussion-title\">\n            ";
  stack1 = self.invokePartial(partials['ui/features/discussion_topic/jst/_author_link.handlebars'], 'ui/features/discussion_topic/jst/_author_link.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </div>\n          <div class=\"discussion-pubdate hide-if-collapsed\">"
    + escapeExpression((helper = helpers.friendlyDatetime || (depth0 && depth0.friendlyDatetime),options={hash:{
    'pubdate': (true),
    'contextSensitive': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), options) : helperMissing.call(depth0, "friendlyDatetime", (depth0 && depth0.created_at), options)))
    + "</div>\n        </div>\n      </div>\n    </header>\n    <div class=\"discussion-section message_wrapper\">\n      <div class=\"message user_content\">"
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.message), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.message), options)))
    + "</div>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.editor), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.attachments), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"entry-controls\">\n      <a href=\"#entry-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"viewInDiscussion\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.results_entry")
  },data:data},helper ? helper.call(depth0, "discussions.results_entry.view_in_discussion", "View in discussion", options) : helperMissing.call(depth0, "t", "discussions.results_entry.view_in_discussion", "View in discussion", options)))
    + "</a>\n    </div>\n  </div>\n</article>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  